import { plainToClass } from 'class-transformer';
import { ValidationError } from 'class-validator';
import { BaseCohortFacade } from '../../common';
import { ReadCohortTemplateDto } from '../generated-dto';
import { CohortTemplateExposeGroup } from '../interface';
export class CohortTemplateFacade extends BaseCohortFacade {
    constructor() {
        super(...arguments);
        this.baseApiURL = 'api/v2/cohort-templates';
    }
    async list() {
        const result = await this.client.get(`/${this.baseApiURL}`);
        return plainToClass(ReadCohortTemplateDto, result.data, {
            groups: [CohortTemplateExposeGroup.READ],
        });
    }
    async get(uuid) {
        return plainToClass(ReadCohortTemplateDto, (await this.client.get(`/${this.baseApiURL}/${uuid}`)).data, {
            groups: [CohortTemplateExposeGroup.READ],
        });
    }
    async validate(uuid) {
        return plainToClass(ValidationError, (await this.client.put(`/${this.baseApiURL}/${uuid}/validate`)).data);
    }
}
//# sourceMappingURL=CohortTemplateFacade.js.map